import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Navigate } from 'react-router-dom';
import useAuth from '../../hooks/useAuth';
import LoadingProvider from '../loading/LoadingProvider';
import { Footer } from '@vt/vt-ui';

GuestGuard.propTypes = {
  children: PropTypes.node
};

const ImportantZa = () => {
  return (
    <div className="pb-4 text-center text-xs font-normal text-[#aaaaaa] bg-[#1a1a1a] rounded-[16px] leading-[16.39px] mt-[42px] px-2 py-4">
      Important Note: By completing and submitting this form you acknowledge and accept that you are
      registering an account with IUX Markets (MU) Ltd., which is authorized and regulated by the
      Financial Services Commission (FSC) in Mauritius with investment dealer license number
      GB22200605. IUX Markets ZA (Pty) Ltd. acts solely as an intermediary in terms of the FAIS Act,
      rendering only an intermediary service (i.e., no market making is conducted by IUX Markets ZA
      (Pty) Ltd.) in relation to derivative products (CFDs) offered by IUX Markets (MU) Ltd. (i.e.,
      the Product Supplier). IUX Markets (MU) Ltd. falls outside the regulatory framework of South
      Africa and FSCA’s oversight and as such, FSC’s laws and regulations will apply in relation to
      your account.
    </div>
  );
};

export default function GuestGuard({ children }) {
  const { isAuthenticated, isInitialized, location } = useAuth();

  if (isAuthenticated) {
    return <Navigate to="/trade-panel" />;
  }

  if (isInitialized) {
    if (window.location.origin.includes('iuxmarkets')) {
      window.location.replace('https://trading.iux.com');
    }
    return <LoadingProvider />;
  }

  document.body.style.overflow = 'auto';

  return (
    <div className="bg-neutral-black">
      <div id="loginForm" className="login-form">
        <div className="px-4 lg:px-8 pb-8 py-10 container mx-auto">
          <div className="text-[#aaaaaa] text-md font-sans text-center mb-4">
            Trade Responsibly: CFDs are complex instruments and come with a high risk of losing
            money rapidly due to leverage.{' '}
            <span className="font-bold">
              {' '}
              67.83% of retail investor accounts lose money when trading CFDs with this provider.{' '}
            </span>{' '}
            You should consider whether you understand how CFDs work and whether you can afford to
            take the high risk of losing your
          </div>
          {location === 'ZA' && <ImportantZa />}
          <div className="mb-[40px]" />
          {children}
        </div>
      </div>
      <div className='bg-[#151515]'>
        <div className="dark container mx-auto p-6">
          <Footer domain="default" lang="en" />
        </div>
      </div>
    </div>
  );
}
